import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import axios from "axios";
import "./EventRegistration.css"; // Custom styles for this form
import Select from "react-select";
import { Helmet } from "react-helmet-async" ;


const EventRegistration = () => {
  const { event_id } = useParams();
  const navigate = useNavigate();
  const [eventDetails, setEventDetails] = useState(null);
  const [formData, setFormData] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [discountedPrice, setDiscountedPrice] = useState(null);
  const [disabledFields, setDisabledFields] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [teamLogoFile, setTeamLogoFile] = useState(null);
const [screenshotFile, setScreenshotFile] = useState([]);
const [showTermsModal, setShowTermsModal] = useState(false);
const [modalContent, setModalContent] = useState('');
const [promoterId, setPromoterId] = useState(null);
const [selectedFood, setSelectedFood] = useState([]);
const location = useLocation();

  

  
  // Load event details
 useEffect(() => {
  axios
    .get(`${process.env.REACT_APP_API_URL}/get_event_details.php?event_id=${event_id}`)
    .then((response) => {
      setEventDetails(response.data);
    })
    .catch((error) => {
      if (error.response && error.response.status === 403) {
        setEventDetails({ closed: true, name: "Event Registration" });
      } else {
        console.error("Error fetching event details:", error);
      }
    });
}, [event_id]);

  
  useEffect(() => {
  const queryParams = new URLSearchParams(location.search);
  const ref = queryParams.get("ref");
  if (ref) {
    setPromoterId(ref);
  }
}, [location.search]);


  // Load Razorpay script dynamically
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => console.log("✅ Razorpay script loaded successfully");
    script.onerror = () => console.error("❌ Razorpay script failed to load");
    document.body.appendChild(script);
  }, []);

  const handleChange = async (e) => {
  const { name, value } = e.target;

  // Check if it's the phone field (only digits, max 10)
  if (name === "phone") {
    if (/^\d{0,10}$/.test(value)) {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  } else {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  // Handle disabling of related fields
  if (["referral", "coupon_code", "group_size", "day"].includes(name)) {
    const hasValue = value.trim() !== "";

    const updatedDisabledFields = {
      referral: name !== "referral" && hasValue,
      coupon_code: name !== "coupon_code" && hasValue,
      group_size: name !== "group_size" && hasValue,
      day: name !== "day" && hasValue,
    };

    setDisabledFields(
      hasValue
        ? updatedDisabledFields
        : {
            referral: false,
            coupon_code: false,
            group_size: false,
            day: false,
          }
    );
  }

  // Handle referral or coupon discount check
  if (name === "referral" || name === "coupon_code") {
    await checkDiscount();
  }

  // Group size discount
  if (name === "group_size") {
    if (groupDiscounts[value]) {
      setDiscountedPrice(groupDiscounts[value]);
    } else {
      setDiscountedPrice(null);
    }
  }

  // Day-based discount
  if (name === "day") {
    if (dayDiscounts[value]) {
      setDiscountedPrice(dayDiscounts[value]);
    } else {
      setDiscountedPrice(null);
    }
  }
};


  // Check discount on coupon/referral/group
 // Check discount on coupon/referral/group
const checkDiscount = async () => {
  const { referral, coupon_code, group_size } = formData;

  const event_id = eventDetails?.id;
  if (!event_id) return; // Skip silently if no event selected

  try {
    const response = await axios.post("https://esmaaash.in/esmaaash_web/backend/api/check_discount.php", {
      event_id,
      referral,
      coupon_code,
      group_size,
    });

    if (response.data.discounted_price) {
      setDiscountedPrice(response.data.discounted_price); // Apply silently
    } else {
      setDiscountedPrice(null); // No discount or invalid → revert to base
    }
  } catch (error) {
    // Silently handle all errors
    console.warn("Discount check error:", error.message);
    setDiscountedPrice(null);
  }
};


  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Ensure eventDetails exists
    if (!eventDetails || !eventDetails.id || !eventDetails.price) {
        alert("⚠ Event details missing. Please refresh the page.");
        console.error("⚠ Event details are undefined:", eventDetails);
        setIsSubmitting(false);
        return;
    }

    // Determine final price after discount (if applicable)
const finalAmount = finalAmountToPay;  // already calculated above with food

    // Ensure formData exists
  let requiredFields = [];

try {
  requiredFields = Array.isArray(eventDetails.required_fields)
    ? eventDetails.required_fields
    : JSON.parse(eventDetails.required_fields || '[]');
} catch (e) {
  console.warn("Invalid required_fields format:", eventDetails.required_fields);
  requiredFields = [];
}

const missingFields = requiredFields.filter((field) => {
  return !formData[field] || formData[field].toString().trim() === "";
});

if (missingFields.length > 0) {
  alert(`⚠ Please fill all required fields: ${missingFields.join(", ")}`);
  console.warn("Missing fields:", missingFields);
  setIsSubmitting(false);
  return;
}



    try {
        console.log("Promoter ID captured:", promoterId);

        const registrationData = {
  event_id: eventDetails.id,
  team_name: formData.team_name || null,
  name: formData.name || null,
  email: formData.email || null,
  phone: formData.phone || null,
  coupon_code: formData.coupon_code || null,
  referral_code: formData.referral || null,
  group_size: formData.group_size || null,
  final_price: finalAmount,
  school_name: formData.school_name || null,
  age_group: formData.age_group || null,
  dob: formData.dob || null, 
  igl_name: formData.igl_name || null,
  substitute_name: formData.substitute_enabled ? formData.substitute_name || null : null,
substitute_contact: formData.substitute_enabled ? formData.substitute_contact || null : null,
  fide_id: formData.fide_id || null, 
    selected_city: formData.selected_city || null, // ✅ Add this line
  team_members: [] , // New field for backend
 promoter_id: promoterId,
  prebook_food: selectedFood.map(f => ({ name: f.name, price: f.price }))
            
        };


 for (let i = 1; i <= (eventDetails.team_size || 0); i++) {
    const name = formData[`member${i}_name`] || "";
    const contact = formData[`member${i}_contact`] || "";

    if (name.trim() !== "") {
      registrationData.team_members.push({ name, contact: contact || null });
    }
  }

        console.log("📨 Sending Registration Data:", registrationData);
const payload = new FormData();

Object.entries(registrationData).forEach(([key, value]) => {
  if (value !== null && value !== undefined) {
    if (key === "prebook_food") {
      payload.append(key, JSON.stringify(value)); // ✅ FIX
    } else {
      payload.append(key, value);
    }
  }
});


// Attach files if available
if (teamLogoFile) {
  payload.append("team_logo", teamLogoFile);
}

if (screenshotFile && screenshotFile.length > 0) {
  screenshotFile.forEach((file) => {
    payload.append("screenshot[]", file); // use [] to indicate array
  });
}

        const response = await axios.post(
  `${process.env.REACT_APP_API_URL || "https://esmaaash.in/esmaaash_web/backend/api"}/register_event.php`,
  payload,
  { headers: { "Content-Type": "multipart/form-data" } }
);


        console.log("✅ Server Response:", response.data);

        if (response.data.success) {

  const { registration_id, order_id } = response.data;

  if (Number(finalAmount) === 0) {
    setSuccessMessage(" Registration completed successfully without payment! Please Follow Esmaaash Instagram for More Updates");
    setTimeout(() => navigate("/events"), 10000);
  } else {
    processPayment(registration_id, finalAmount, order_id); // Pass order_id here
  }

      } else {
        alert("❌ Registration failed: " + response.data.error);
      }
    } catch (error) {
      console.error("❌ Registration error:", error);
      alert("❌ Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

const loadRazorpayScript = async () => {
    return new Promise((resolve) => {
        if (window.Razorpay) {
            resolve(true);
            return;
        }

        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
};

const processPayment = async (registrationId, finalAmount, order_id) => {
    const razorpayLoaded = await loadRazorpayScript();

    if (!razorpayLoaded) {
        alert("❌ Razorpay script failed to load. Please refresh and try again.");
        console.error("❌ Razorpay script did not load.");
        return;
    }

    // Ensure event details are available
    if (!eventDetails || !eventDetails.name) {
        alert("⚠ Event details missing. Please try again.");
        console.error("⚠ Event details are undefined:", eventDetails);
        return;
    }

    console.log("🚀 Proceeding with Razorpay Payment:", { finalAmount, registrationId });

  const options = {
    key: process.env.REACT_APP_PAYMENT_KEY,
    amount: finalAmount * 100,
    currency: "INR",
    name: "Smaaash Events",
    description: `Payment for ${eventDetails.name}`,
    order_id: order_id, // ✅ Use backend order_id here
    handler: async (response) => {
      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL || "https://esmaaash.in/esmaaash_web/backend/api"}/update_payment_status.php`,
          {
            registration_id: registrationId,
            razorpay_payment_id: response.razorpay_payment_id,
             razorpay_order_id: response.razorpay_order_id,
            payment_status: "paid",
            paid_amount: finalAmount,
            coupon_code: formData.coupon_code || null,
          }
        );
        setSuccessMessage("✅ Payment Successful! Registration Completed. Please Follow Esmaaash Instagram for More Updates");
        setTimeout(() => navigate("/events"), 10000);
      } catch (error) {
        console.error("❌ Payment update failed:", error);
        alert("⚠ Payment successful, but failed to update. Contact support.");
      }
    },
    prefill: {
      name: formData.name || "",
      email: formData.email || "",
      contact: formData.phone || "",
    },
    notes: {
      event_id: eventDetails.id,
      coupon_code: formData.coupon_code || "",
    },
    theme: { color: "#3399cc" },
  };
    console.log("⚡ Creating Razorpay instance...");
  const razorpayInstance = new window.Razorpay(options);
  razorpayInstance.open();
};

  if (!eventDetails) return <div className="loading">Loading event details...</div>;
  
  const eventEndDate = new Date(eventDetails.end_date || eventDetails.event_date);
const now = new Date();
const isEventPast = eventEndDate < now;

if (eventDetails.registration_closed || eventDetails.closed || isEventPast) {
  return (
    <div className="registration-container">
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
        <title>{eventDetails.name} | Registration Closed</title>
      </Helmet>

      <h1 className="registration-title">{eventDetails.name}</h1>
      <p style={{ color: "red", fontSize: "20px", fontWeight: "bold" }}>
        🚫 Registration Closed – You can no longer register for this event.
      </p>
    </div>
  );
}


  const requiredFields = eventDetails?.required_fields
  ? eventDetails.required_fields.split(",").map(field => field.trim()).filter(Boolean)
  : [];
console.log("Parsed Required Fields:", requiredFields);

  const restrictedCities = (eventDetails.restricted_cities || "")
    .split(",")
    .map((city) => city.trim())
    .filter(Boolean);

    // 🔹 Fix: Define `groupDiscounts`
const groupDiscounts = eventDetails?.group_discount
? JSON.parse(eventDetails.group_discount)
: {};

const dayDiscounts = eventDetails?.day_discount
  ? JSON.parse(eventDetails.day_discount)
  : {};


const rawAgeGroups = eventDetails?.age_groups;
let ageGroups = [];

if (rawAgeGroups) {
  try {
    ageGroups = JSON.parse(rawAgeGroups); // Already an array of strings
  } catch (e) {
    console.error("Invalid age_groups JSON", e);
  }
}


  
console.log("Parsed Group Discounts:", groupDiscounts);
console.log("Required Fields:", requiredFields);
console.log("eventDetails.age_groups:", eventDetails?.age_groups);
console.log("Parsed ageGroups:", ageGroups);

const teamSize = eventDetails?.team_size || 0;

  // ✅ Add this line below to fix the button logic
 // Update button price live
// Base (event price or discounted)
let basePrice = discountedPrice !== null
  ? parseFloat(discountedPrice)
  : parseFloat(eventDetails?.price || 0);

// Add food price
let foodPrice = selectedFood.reduce((sum, food) => sum + parseFloat(food.price), 0);

const finalAmountToPay = basePrice + foodPrice;


    return (
      <div className="registration-container">
        <h1 className="registration-title">Register for {eventDetails.name}</h1>
    
        <form className="registration-form" onSubmit={handleSubmit}>
        
        <input
  type="hidden"
  name="promoter_id"
  value={formData.promoter_id}
/>

        
          {requiredFields.includes("Team Name") && (
            <input type="text" name="team_name" placeholder="Your Team Name" onChange={handleChange} required />
          )}
          
          {requiredFields.includes("IGL Name") && (
            <input type="text" name="igl_name" placeholder="IGL Name" onChange={handleChange} required />
          )}
          
          {requiredFields.includes("Name") && (
            <input type="text" name="name" placeholder="Your Name" onChange={handleChange} required />
          )}
          {requiredFields.includes("Email") && (
            <input type="email" name="email" placeholder="Your Email" onChange={handleChange} required />
          )}
         {requiredFields.includes("Phone") && (
  <input
    type="tel"
    name="phone"
    placeholder="Your Phone Number"
    onChange={handleChange}
    required
    pattern="[0-9]{10}"
    maxLength="10"
    inputMode="numeric"
    title="Please enter a valid 10-digit phone number"
  />
)}

          
          
{requiredFields.includes("School Name") && (
<input type="text" name="school_name" placeholder="Your School Name" value={formData.school_name} onChange={handleChange} />

          )}
          
       {ageGroups.length > 0 && (
  <select name="age_group" onChange={handleChange}>
    <option value="">Select age group</option>
    {ageGroups.map((label, index) => (
      <option key={index} value={label}>{label}</option>
    ))}
  </select>
)}


          
          {requiredFields.includes("Age") && (
            <input type="number" name="age" placeholder="Your Age" onChange={handleChange} />
          )}
          {requiredFields.includes("Referral Code") && (
            <input type="text" name="referral" placeholder="Referral Code (Optional)" onBlur={checkDiscount} onChange={handleChange} disabled={disabledFields.referral} />
          )}
{requiredFields.includes("Coupon") && (
  <>
    <input
      type="text"
      name="coupon_code"
      placeholder="Enter Coupon Code"
      value={formData.coupon_code || ""}
      onChange={handleChange}
      disabled={disabledFields.coupon_code}
    />
    <button
      type="button"
      onClick={checkDiscount}
      className="apply-coupon-btn"
    >
      Apply Coupon
    </button>
    {discountedPrice !== null && (
      <p className="discount-info">
        🎉 Discount Applied! New Price: ₹{discountedPrice}
      </p>
    )}
  </>
)}

    
          {/* Group Discount Dropdown */}
          {Object.keys(groupDiscounts).length > 0 && (
            <select name="group_size" onChange={handleChange} disabled={disabledFields.group_size} >
              <option value="">Select Group Size</option>
              {Object.keys(groupDiscounts).map((size) => (
                <option key={size} value={size}>
                  {size} People
                </option>
              ))}
            </select>
          )}
          
          {Object.keys(dayDiscounts).length > 0 && (
  <select name="day" onChange={handleChange}>
    <option value="">Select No. of Days</option>
    {Object.keys(dayDiscounts).map((dayKey) => (
      <option key={dayKey} value={dayKey}>
        {dayKey}
      </option>
    ))}
  </select>
)}

    
    {restrictedCities.length > 0 && (
  <select
    name="selected_city"
    onChange={handleChange}
    value={formData.selected_city || ""}
    required={requiredFields.includes("Location")} // ✅ Mark as required
  >
    <option value="">Select Your City</option>
    {restrictedCities.map((city, index) => (
      <option key={index} value={city}>
        {city}
      </option>
    ))}
  </select>
)}

          
          {teamSize > 0 && (
  <div className="team-members-section">
    <h3>Team Players</h3>
    {Array.from({ length: teamSize }, (_, i) => (
      <div key={i} className="team-member-inputs">
        <input
          type="text"
          name={`member${i + 1}_name`}
          placeholder={`Member ${i + 1} Name`}
          required
          onChange={handleChange}
        />
       <input
  type="tel"
  name={`member${i + 1}_contact`}
  placeholder={`Member ${i + 1} Contact (optional)`}
  onChange={handleChange}
  pattern="[0-9]{10}"
  maxLength="10"
  inputMode="numeric"
  title="Please enter a 10-digit phone number"
/>

      </div>
    ))}
  </div>
)}

{requiredFields.includes("Substitute Name") && (
  <input
    type="text"
    name="substitute_name"
    placeholder="Substitute Player Name (optional)"
    onChange={handleChange}
  />
)}

{requiredFields.includes("Substitute Contact") && (
  <input
  type="tel"
  name="substitute_contact"
  placeholder="Substitute Player Contact (optional)"
  onChange={handleChange}
  pattern="[0-9]{10}"
  maxLength="10"
  inputMode="numeric"
  title="Please enter a 10-digit phone number"
/>
)}



{requiredFields.includes("Date of Birth") && (
  <div className="form-group">
    <label htmlFor="dob">Date of Birth</label>
    <input
      type="date"
      id="dob"
      name="dob"
      onChange={handleChange}
      value={formData.dob || ""}
      required
    />
  </div>
)}

{requiredFields.includes("Team Logo") && (
  <div>
    <label>Upload Team Logo</label>
    <input
      type="file"
      accept="image/*"
      name="team_logo"
      required
      onChange={(e) => setTeamLogoFile(e.target.files[0])}
    />
  </div>
)}

{requiredFields.includes("Screenshot") && (
  <div>
    <label>Upload Screenshot(s)</label>
    <input
      type="file"
      accept="image/*"
      name="screenshot"
      multiple
      onChange={(e) => {
        const files = e.target.files;
        if (files.length > 0) {
          setScreenshotFile([...files]);
        } else {
          setScreenshotFile([]); // handle null/empty
        }
      }}
    />
  </div>
)}


{requiredFields.includes("FIDE Rating ID") && (
  <input
    type="text"
    name="fide_id"
    placeholder="FIDE Rating ID"
    onChange={handleChange}
    value={formData.fide_id || ""}
  />
)}

{(eventDetails.enable_food === "1" || eventDetails.enable_food === 1) &&
 Array.isArray(eventDetails.food_menu) && (
  <div className="food-section">
    <h3>🍔 Prebook Food (Optional)</h3>
    <Select
      isMulti
      name="food_menu"
      options={eventDetails.food_menu.map((item) => ({
        value: item.name,
        label: `${item.name} - ₹${item.price}`,
        item, // keep full object
      }))}
      placeholder="Select Food Items"
     onChange={(selectedOptions) => {
  // Remove duplicates based on food name
  const uniqueFood = Array.from(
    new Map(selectedOptions.map(opt => [opt.item.name, opt.item])).values()
  );
  setSelectedFood(uniqueFood);
}}
    />

    {selectedFood.length > 0 && (
      <div className="selected-food mt-2">
        <h4 className="font-semibold">Selected Food:</h4>
        <ul className="list-disc pl-5">
          {selectedFood.map((food, i) => (
            <li key={i}>
              {food.name} - ₹{food.price}
            </li>
          ))}
        </ul>
      </div>
    )}
  </div>
)}




        <div className="agreement-section">
  <label>
    <input type="checkbox" required /> I agree to the{" "}
    <span onClick={() => {
      setModalContent(eventDetails.terms_conditions);
      setShowTermsModal(true);
    }} style={{ color: "blue", cursor: "pointer" }}>
      Terms & Conditions
    </span>{" "}
    and{" "}
    <span onClick={() => {
      setModalContent(eventDetails.event_rules);
      setShowTermsModal(true);
    }} style={{ color: "blue", cursor: "pointer" }}>
      Event Rules
    </span>.
  </label>
</div>
{showTermsModal && (
  <div className="modal-overlay">
    <div className="modal-box">
      <button onClick={() => setShowTermsModal(false)}>Close</button>
     <div
  className="modal-content"
  style={{ maxHeight: '400px', overflowY: 'auto', color: 'white' }}
  dangerouslySetInnerHTML={{ __html: modalContent.replace(/\n/g, "<br>") }}
></div>

    </div>
  </div>
)}


         {/* ✅ Button text based on final price */}
        <button type="submit" className="submit-btn" disabled={isSubmitting}>
          {isSubmitting
            ? "Processing..."
            : finalAmountToPay === 0
            ? "🎉 Register"
            : `🚀 Pay & Register ₹${finalAmountToPay}`}
        </button>


        {successMessage && <div className="success-message">{successMessage}</div>}
      </form>
    </div>
  );
};

export default EventRegistration;